import { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      await fetch('https://readdy.ai/api/form/d6vqhbm7ipaugi04lob0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-12 sm:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 mb-10 sm:mb-12">
          <div className="col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <img
                src="/assets/readdy/static-358c7e6691b9b58b5179c58a2715558b.jpg"
                alt="NexusGo"
                className="w-8 h-8 rounded-lg object-cover"
              />
              <span className="font-bold text-lg">NexusGo</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              連結全球頂尖 AI 科技導師與新一代 AI 人才，助你掌握全球職涯命運。
            </p>
            <div className="flex items-center gap-3">
              {['ri-linkedin-fill', 'ri-twitter-x-fill', 'ri-youtube-fill', 'ri-wechat-fill'].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 text-slate-300 hover:bg-violet-600 hover:text-white transition-all cursor-pointer"
                  >
                    <i className={`${icon} text-sm`} />
                  </a>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">平台</h4>
            <ul className="space-y-3">
              {[
                { label: '找導師', path: '/mentors' },
                { label: '會員訂閱', path: '/services' },
                { label: '成功案例', path: '/mentors' },
                { label: '導師入駐', path: '/contact' },
                { label: '企業合作', path: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-slate-400 text-sm hover:text-white transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">訂閱 AI 職涯洞察</h4>
            <p className="text-slate-400 text-sm mb-4 leading-relaxed">
              每週精選全球 AI 就業趨勢、頂尖外商 Offer 攻略，直送你的信箱。
            </p>
            {submitted ? (
              <div className="flex items-center gap-2 text-violet-400 text-sm">
                <i className="ri-check-circle-line" />
                訂閱成功！精彩內容即將送達
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleNewsletterSubmit}
                className="flex flex-col gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="bg-white/10 border border-white/15 rounded-lg px-4 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-violet-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-violet-600 text-white text-sm font-semibold py-2.5 rounded-lg hover:bg-violet-700 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {submitting ? '訂閱中...' : '立即訂閱'}
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center sm:justify-between gap-3 sm:gap-0 text-center sm:text-left">
          <p className="text-slate-500 text-xs">
            © 2026 NexusGo Technology Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
            {[
              { label: '隱私政策', path: '/legal' },
              { label: '退款政策', path: '/legal?tab=refund' },
              { label: 'Cookie 設定', path: '/legal?tab=cookie' },
            ].map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className="text-slate-500 text-xs hover:text-slate-300 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
